import Vue from 'vue';
import phase from '../../utils/phase';

import template from './index.html';

export default Vue.extend({
  name: 'PhaseWrapper',
  props: [
    'phase',
  ],
  template,

  data() {
    return {
      isActive: false,
    };
  },

  methods: {
    getCurrentPhase() {
      const currentPhase = phase();
      const phases = this.phase.split(',');

      this.isActive = phases.includes(currentPhase);
    },
  },


  mounted() {
    this.getCurrentPhase();

    window.setInterval(() => {
      this.getCurrentPhase();
    }, 1000);
  },
});



// WEBPACK FOOTER //
// ./src/js/components/phase-wrapper/index.js